import { create } from 'zustand';
import { UserRole } from './draft.input';

export interface DeveloperInputState {
  role: UserRole;
  userAllowed: boolean | null;
}

interface WhitelistAction {
  setValue<K extends keyof DeveloperInputState>(
    key: K,
    value: DeveloperInputState[K],
  ): void;
  clear(): void;
}

type DeveloperStoreType = DeveloperInputState & WhitelistAction;

export const useDeveloperInputStore = create<DeveloperStoreType>((set) => ({
  userAllowed: null,
  role: 'developer-portal',
  setValue(key, value) {
    set((state) => ({
      [key]: value,
    }));
  },
  clear: () => {
    set((state) => ({ role: null, userAllowed: null }));
  },
}));
